(function () {
  'use strict';

  class InfiniteScrollGrid extends HTMLElement {

    connectedCallback() {

      this.grid = document.querySelector('#product-grid');

      this.spinner = this.querySelector(
        '.infinite-scroll__spinner'
      );

      this.sentinel = this.querySelector(
        '.infinite-scroll__sentinel'
      );

      this.nextUrl =
        this.getAttribute('data-next-url') || '';

      this.loading = false;

      if (!this.grid) {
        console.warn(
          '[Infinite Scroll] #product-grid not found'
        );
        return;
      }

      if (!this.nextUrl) {
        console.log(
          '[Infinite Scroll] No next URL'
        );
        return;
      }

      /*
       * Use IntersectionObserver instead of
       * calculating document height.
       */
      if (this.sentinel) {

        this.observer = new IntersectionObserver(
          (entries) => {

            if (
              entries[0].isIntersecting &&
              !this.loading &&
              this.nextUrl
            ) {
              this.loadMore();
            }

          },
          {
            root: null,

            /*
             * Start loading before the user
             * actually reaches the sentinel.
             */
            rootMargin: '1500px 0px 1500px 0px',

            threshold: 0
          }
        );

        this.observer.observe(this.sentinel);

      } else {

        /*
         * Fallback if sentinel is missing.
         */
        this.checkScroll =
          this.checkScroll.bind(this);

        window.addEventListener(
          'scroll',
          this.checkScroll,
          { passive: true }
        );

        window.addEventListener(
          'resize',
          this.checkScroll
        );

        this.checkScroll();
      }

      console.log(
        '[Infinite Scroll] Initialized',
        this.nextUrl
      );
    }


    disconnectedCallback() {

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.checkScroll) {

        window.removeEventListener(
          'scroll',
          this.checkScroll
        );

        window.removeEventListener(
          'resize',
          this.checkScroll
        );
      }
    }


    checkScroll() {

      if (
        this.loading ||
        !this.nextUrl
      ) {
        return;
      }

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      const windowHeight =
        window.innerHeight;

      const documentHeight =
        Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );

      const remaining =
        documentHeight -
        scrollTop -
        windowHeight;

      if (remaining <= 600) {
        this.loadMore();
      }
    }


    async loadMore() {

      if (
        this.loading ||
        !this.nextUrl
      ) {
        return;
      }

      this.loading = true;

      const url = this.nextUrl;

      console.log(
        '[Infinite Scroll] Loading:',
        url
      );


      /*
       * SHOW LOADER
       */
      if (this.spinner) {

        this.spinner.classList.add(
          'is-loading'
        );
      }


      try {

        /*
         * FETCH NEXT COLLECTION PAGE
         */
        const response = await fetch(
          url,
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          }
        );


        if (!response.ok) {

          throw new Error(
            'HTTP ' + response.status
          );
        }


        const html =
          await response.text();


        /*
         * PARSE HTML
         */
        const doc =
          new DOMParser().parseFromString(
            html,
            'text/html'
          );


        /*
         * FIND NEXT PAGE PRODUCT GRID
         */
        const newGrid =
          doc.querySelector(
            '#product-grid'
          );


        if (!newGrid) {

          console.warn(
            '[Infinite Scroll] Next #product-grid not found'
          );

          this.nextUrl = '';

          this.removeAttribute(
            'data-next-url'
          );

          return;
        }


        /*
         * GET PRODUCT CARDS
         *
         * Your collection page uses:
         *
         * <li class="grid__item">
         *
         */
        const products =
          newGrid.querySelectorAll(
            'li.grid__item'
          );


        console.log(
          '[Infinite Scroll] Products found:',
          products.length
        );


        if (!products.length) {

          console.warn(
            '[Infinite Scroll] No products found'
          );

          this.nextUrl = '';

          return;
        }


        /*
         * APPEND PRODUCTS
         */
        products.forEach(
          (product) => {

            this.grid.appendChild(
              product.cloneNode(true)
            );

          }
        );


        /*
         * FIND NEXT PAGE URL
         */
        const newInfinite =
          doc.querySelector(
            'infinite-scroll-grid[data-next-url]'
          );


        if (newInfinite) {

          this.nextUrl =
            newInfinite.getAttribute(
              'data-next-url'
            ) || '';

        } else {

          /*
           * Fallback to Shopify's
           * normal next pagination link.
           */
          const nextLink =
            doc.querySelector(
              'a[rel="next"]'
            );


          if (nextLink) {

            this.nextUrl =
              nextLink.href;

          } else {

            this.nextUrl = '';
          }
        }


        /*
         * UPDATE CURRENT ELEMENT
         */
        if (this.nextUrl) {

          this.setAttribute(
            'data-next-url',
            this.nextUrl
          );

          console.log(
            '[Infinite Scroll] Next URL:',
            this.nextUrl
          );

        } else {

          this.removeAttribute(
            'data-next-url'
          );

          console.log(
            '[Infinite Scroll] No more products'
          );
        }


        /*
         * Small delay so the loader is visible
         * and the DOM has time to update.
         */
        await new Promise(
          (resolve) => {
            setTimeout(resolve, 100);
          }
        );


      } catch (error) {

        console.error(
          '[Infinite Scroll] Error:',
          error
        );


      } finally {

        /*
         * HIDE LOADER
         */
        if (this.spinner) {

          this.spinner.classList.remove(
            'is-loading'
          );
        }


        this.loading = false;


        /*
         * If the newly added products are still
         * not enough to push the sentinel below
         * the viewport, IntersectionObserver will
         * trigger again automatically.
         */
      }
    }
  }


  /*
   * Define only once
   */
  if (
    !customElements.get(
      'infinite-scroll-grid'
    )
  ) {

    customElements.define(
      'infinite-scroll-grid',
      InfiniteScrollGrid
    );

  }

})();
